import { defineClientComponent } from './src/js/clientComponents.ts';
import Component from './src/pages/butikk/[id].tsx';
defineClientComponent('butikk/[id]', Component);